export default __webpack_public_path__ + "static/media/avatar_149.57eaa0f7.png";